import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const QuestionMarkIcon: SVGFC = ({ color = tailwindColors.grey.DEFAULT, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 11C0 4.92487 4.92487 0 11 0V0C17.0751 0 22 4.92487 22 11V11C22 17.0751 17.0751 22 11 22V22C4.92487 22 0 17.0751 0 11V11Z"
        fill={color}
      />
      <g clipPath="url(#clip0_9493_440764)">
        <path
          d="M11 2.81445C6.47861 2.81445 2.81445 6.47861 2.81445 11C2.81445 15.5214 6.47861 19.1855 11 19.1855C15.5214 19.1855 19.1855 15.5214 19.1855 11C19.1855 6.47861 15.5214 2.81445 11 2.81445ZM10.6777 15.9113C10.2298 15.9113 9.86885 15.5504 9.86885 15.1024C9.86885 14.6545 10.2298 14.2936 10.6777 14.2936C11.1257 14.2936 11.4866 14.6545 11.4866 15.1024C11.4866 15.5504 11.1225 15.9113 10.6777 15.9113ZM12.476 11.0935C11.7573 11.6381 11.2836 11.9958 11.2836 13.2978C11.2836 13.6394 11.0064 13.9165 10.6648 13.9165C10.3232 13.9165 10.0461 13.6394 10.0461 13.2978C10.0461 11.3803 10.9388 10.7035 11.7283 10.1073C11.8347 10.0268 12.4373 9.65937 12.4373 8.84082C12.4373 8.00615 11.7573 7.32617 10.9227 7.32617C10.2975 7.32617 9.74639 7.7 9.51436 8.28008C9.38867 8.5959 9.02773 8.75059 8.71191 8.6249C8.39609 8.49922 8.24141 8.13828 8.36709 7.82246C8.78604 6.77187 9.78828 6.09189 10.9227 6.09189C12.4405 6.09189 13.6716 7.32617 13.6716 8.84082C13.6748 10.2652 12.5888 11.0064 12.476 11.0935Z"
          fill={props.color2}
        />
      </g>
      <defs>
        <clipPath id="clip0_9493_440764">
          <rect width="16.5" height="16.5" fill="white" transform="translate(2.75 2.75)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default QuestionMarkIcon
